$(document).ready(function() {
$('.readmore').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'block';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'none';
});
$('.readless').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'none';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'block';
});  
  
  $('.announcementbar-messgaes').owlCarousel({
    loop: true,
    responsiveClass: true,
    autoplay: true,
    dots: false,
    items: 1
  });
  
  $('.recently-viewed').owlCarousel({
    loop: false,
    responsiveClass: true,
    autoplay: true,
    dots: false,
    responsive: {
      0: {
        items: 1,
        nav: false,
        stagePadding: 40,
        margin: 20
      },
      600: {
        items: 3,
        nav: false
      },
      1400: {
        items: 4,
        nav: false
      }
    }
  });
  
    $('.ele-collection-slider').owlCarousel({
      margin:10,
      nav:true,
      dots:false,
      lazyLoad:true,
      autoplay: true,
      loop:false,
      autoWidth:true,
      autoplayHoverPause: true,
      responsive:{
        0:{
          items: 2,
          nav: true,
          stagePadding: 15
        },
        600:{
          items: 3
        },
        1000:{
          items: 8
        }
      }
    });
    $(window).on("resize", function (e) {
        checkScreenSize();
    });

    checkScreenSize();
    
    function checkScreenSize(){
        var newWindowWidth = $(window).width();
        if (newWindowWidth < 768) {
            $(document).ready(function() {
              $('.shippingshow-section').owlCarousel({
                loop: false,
                responsiveClass: true,
                responsive: {
                  0: {
                    items: 1,
                    nav: true
                  },
                  600: {
                    items: 1,
                    nav: false
                  },
                  1600: {
                    items: 1,
                    nav: false,
                    loop: false
                  }
                }
              });
            });
        }
    }
  
    $('.tabs-nav li a').click(function(){
      $('.tab-content').hide();
      $('.tabs-nav li a.active').removeClass('active');
      $(this).addClass('active');
      var panel = $(this).attr('href');
      $(panel).fadeIn();
      return false;  // prevents link action
    });  // end click 
    $('.tabs-nav li:first a').click();
  
  $('#createacc').click(function() {
  	$('#sign-up-elevate').fadeIn();
    $('#login-elevate').hide();
  });
  $('#alreadyacc_signin').click(function() {
  	$('#sign-up-elevate').hide();
    $('#login-elevate').fadeIn();
  });
  
  $('.password-show .eye').click(function() {
    $(this).hide();
    $('.closeeye').show();
  	$('input.auth-input.pass').attr('type', 'text');
  });
  
  $('.password-show .closeeye').click(function() {
    $(this).hide();
    $('.eye').show();
  	$('input.auth-input.pass').attr('type', 'password');
  });
  
  $('#RecoverPassword').click(function(e) {
  	e.preventDefault();
    $('#RecoverPasswordForm').removeClass('hide');
    $('#RecoverPasswordForm').show();
    $('#login-elevate').hide();
  });
  
  
  $('#HideRecoverPasswordLink').click(function(e) {
  	e.preventDefault();
    $('#RecoverPasswordForm').addClass('hide');
    $('#RecoverPasswordForm').hide();
    $('#login-elevate').show();
  });
  
  $('form#localization_formtoolbarmenu .disclosure__toggle').on('click', function() {
  	console.log('here');
    $('#CurrencyList-toolbarmenu').toggleClass('disclosure-list--visible');
  });
  
  
  $('form#localization_formtoolbarmenu .disclosure-list__option').on('click', function(e) {
    e.preventDefault();
    var a = $(this).attr('data-value');
    
    $('input[name="country_code"]').val(a);
    $(this).parent().parent().parent().parent().parent().submit();
  });
 
    $('.togglemodalclearpay').click(function() {
      $('.afterpay-modal-overlay').addClass('visible');
    });
  
    $('.afterpay-close-button').click(function() {
      $('.afterpay-modal-overlay').removeClass('visible');
    });    

  $(document).on('click', '#afterpay-modal-component .visible', function() {
    $('.afterpay-modal-overlay').removeClass('visible');
  });
  
})


$(document).on('click', '.metaproducts_ele .variant-input', function(event) {
    var vl = $(this).attr('data-value');
    $('.arne-color-swatch-element').removeClass('disabled_div');
    $('.arne-color-swatch-element').each(function() {
      var x = JSON.parse($(this).find('script').html());
      var that = $(this);
      var vav = false;
    
      var hr = that.attr('rel_handle');
      x.forEach(function(v, i) {
        if (v.option1 == vl || v.option2 == vl || v.option3 == vl) {
          if (v.available) {} else {
            that.addClass('disabled_div');
          }
          vav = true;
          if (that.hasClass('active')) {} else {
            var hrl = hr+'?variant='+v.id;

            if (vl == v.title) {
              that.find('a').attr('href', hrl);
            }
          }
        }
      });
      if (vav) {
      } else {
        that.addClass('disabled_div');
      }
    });
});



  (function() {
    function initTabbedCarousel(container) {
      var $container = $(container || document);
      
      // Initialize active tab carousel first
      $container.find('.tabber_based_collection_section:visible .featured_collection_carousel').each(function() {
        if (!$(this).hasClass('owl-loaded')) {
          initOwl($(this));
        }
      });

      // Tab Button Click Handler
      $container.find('.coll_tabber_button').off('click').on('click', function() {
        var blockId = $(this).attr('data-block-id');
        var $section = $(this).closest('[data-section-id]');

        $section.find('.coll_tabber_button').removeClass('active');
        $(this).addClass('active');

        $section.find('.tabber_based_collection_section').hide();
        
        var $targetPanel = $section.find('.tabber_based_collection_section[data-block-id="' + blockId + '"]');
        $targetPanel.show();

        var $targetCarousel = $targetPanel.find('.featured_collection_carousel');
        
        // Initialize if not built yet, else refresh dimensions
        if (!$targetCarousel.hasClass('owl-loaded')) {
          initOwl($targetCarousel);
        } else {
          setTimeout(function() {
            $targetCarousel.trigger('refresh.owl.carousel');
          }, 20);
        }
      });
    }

    function initOwl($carousel) {
      $carousel.owlCarousel({
        loop: false,                  // IMPORTANT: Prevents cloning nodes (doubles RAM consumption)
        checkVisible: false,          // Disables continuous visibility checks that cause memory leaks
        responsiveClass: true,
        autoplay: false,
        dots: false,
        nav: false,
        touchDrag: true,
        pullDrag: false,              // Prevents touch overflow bounces crashing Safari
        freeDrag: false,
        responsive: {
          0: {
            items: 1,
            stagePadding: 30,          // Reduced to keep offscreen elements out of GPU cache
            margin: 15
          },
          600: {
            items: 3,
            margin: 15
          },
          1400: {
            items: 4,
            margin: 20
          }
        }
      });
    }

    // Init on DOM ready
    $(document).ready(function() {
      initTabbedCarousel();
    });

    // Support Shopify Theme Editor reloads
    document.addEventListener('shopify:section:load', function(event) {
      initTabbedCarousel(event.target);
    });
  })();
  